export default function StaffSettings() {
    return (
        <div>
            staff settings
        </div>
    );
};